import ArrowIcon from '@/components/landingPage/ArrowIcon';
import CallToActionButton from '@/components/landingPage/CallToActionButton';
import Image from 'next-export-optimize-images/image';
import React, { ReactNode } from 'react';

type TopCallToActionTVProps = {
  children: ReactNode;
  bulletPoints?: string[];
};

const TopCallToActionTV = ({ children, bulletPoints }: TopCallToActionTVProps) => {
  const imageSrc = '/images/tvc_model_summer-campaign.webp';

  return (
    <div className="flyntComponent  componentNew" is="flynt-hero-image-text">
      <div className="container centerMaxWidthContainer container--large container--noTopPadding">
        <div
          data-image-position="imageRight"
          data-mobile-arrangement="content-image-checkmarks"
          data-image-mobile-shape="shape1"
          className="box box--imageRight box--fullHeight box--verticalCenter"
        >
          <div className={`box-inner box-inner--image componentSpacing`}>
            <figure className="figure">
              <Image
                className="figure-image lazyloaded"
                width={1090}
                height={1090}
                priority
                src={imageSrc}
                alt="Frau feiert Oviva App."
              />
            </figure>
          </div>
          <div
            className="box-inner box-inner--content box-inner--contentSpacing-imageRight box-inner--noRatingOrCheckmarks !max-w-[700px]"
            data-mobile-align="mobileAlignAuto"
          >
            <div className="box-inner--content-flex" data-testid="hero-content">
              {children}
              <ul className="flex flex-col gap-4 p-0">
                {bulletPoints?.map((item, index) => (
                  <li key={index} className="flex gap-3 items-center m-0">
                    <ArrowIcon className="shrink-0" />
                    <span className="font-semibold">{item}</span>
                  </li>
                ))}
              </ul>
              <CallToActionButton />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopCallToActionTV;
